
//declare var moment: any;
namespace Nobox {
    @Serenity.Decorators.element('<input type="text"/>')
    @Serenity.Decorators.registerEditor([Serenity.IStringValue, Serenity.IReadOnly])
    export class ContactFileEditor extends Serenity.Widget<any>
        implements Serenity.IStringValue, Serenity.IReadOnly {

        //private value: string;
        constructor(input: JQuery, options: any) {
            super(input, options);

            input.on('keyup.' + this.uniqueName, e => {
                if (e.which === 32 && !this.get_readOnly()) {
                    this.element.trigger('change');
                }
                else {
                    //DateEditor.dateInputKeyup(e);
                }
            });

            //input.on('change.' + this.uniqueName, DateEditor.dateInputChange);
            $('<a class="btn inplace-button upload-file-btn"><b><i class="fa fa-upload text-primary"></i></b></a>')
                .attr("title", "Upload from local")
                .insertAfter(input)
                .click(e => {
                    this.initUploadFile();
                });
            $('<a class="btn inplace-button preview-photo-btn disabled"><b><i class="fa fa-eye text-primary"></i></b></a>')
                .attr("title", "Show Photo")
                .insertAfter(input)
                .click(e => {
                    this.previewPhoto();
                });
            this.addValidationRule(this.uniqueName, e1 => {
                var value = this.get_value();
                if (Q.isEmptyOrNull(value)) {
                    return null;
                } else {

                }
                if (!this.isLink(value)) {
                    this.disabledPreviewBtn();
                    return "Please input a valid photo url";
                } else {
                    this.enablePreviewBtn();
                }

                return null;
            });
            
        }

        isLink(str) {
            try {
                new URL(str);
                return true;
            } catch (err) {
                return false;
            }
            //var urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
            //return urlPattern.test(str);
        }

        initUploadFile() {
            var dlg = new ContactFileDialog();
            dlg.callback = (data) => {
                this.set_value(`${location.origin}/upload/${data.Filename}`)
            }
            dlg.dialogOpen();
        }

        previewPhoto() {
            $.colorbox({ photo: true, href: this.get_value() });
        }

        //getEditValue(property: Serenity.PropertyItem, target): void {
        //    console.log(property, target, "Get Edit Value")
        //}

        //public setEditValue(source: any, property: Serenity.PropertyItem) {
        //    console.log(source, property,"Set Edit Value")
        //}

        get_readOnly(): boolean {
            return this.element.hasClass('readonly');
        }

        set_readOnly(value: boolean): void {

            if (value !== this.get_readOnly()) {
                if (value) {
                    this.element.addClass('readonly').attr('readonly', 'readonly');
                    this.element.nextAll('.btn').addClass('disabled');
                }
                else {
                    this.element.removeClass('readonly').removeAttr('readonly');
                    this.element.nextAll('.btn').removeClass('disabled');
                }
            }
        }

        get_value(): string {
            return this.element.val();
        }

        disabledPreviewBtn() {
            this.element.nextAll(".preview-photo-btn").addClass("disabled");
        }

        enablePreviewBtn() {
            this.element.nextAll(".preview-photo-btn").removeClass("disabled");
        }

        disabledUploadBtn() {
            this.element.nextAll(".upload-file-btn").addClass("disabled");
        }

        enableUploadBtn() {
            this.element.nextAll(".upload-file-btn").removeClass("disabled");
        }

        get value(): string {
            return this.get_value();
        }

        set_value(value: string) {
            if (Q.isEmptyOrNull(value)) {
                this.element.val('');
                this.disabledPreviewBtn();
            } else {
                this.element.val(value);
                this.enablePreviewBtn(); 
            }
        }

        set value(v: string) {
            this.set_value(v);
        }
    }
}